var React = require('react');

function Linkedin (props) {
    props = { ...{"viewBox":"0 0 19 17"}, ...props };
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M13.756 5.34c2.493 0 4.452 1.662 4.452 5.239V17H14.23v-5.976c0-1.564-.622-2.632-1.99-2.632-1.047 0-1.63.72-1.9 1.415-.102.25-.086.596-.086.944V17H6.313v-.095c.005-1.052.048-10.545 0-11.454h3.941v1.813c.233-.793 1.492-1.924 3.502-1.924zm-9.585.111V17H.662V5.451h3.509zM2.35 0c1.295 0 2.09.862 2.116 2.002 0 1.119-.821 2.005-2.14 2.005h-.025c-1.27 0-2.094-.883-2.094-2.002C.208.865 1.056 0 2.351 0z"}));
}

module.exports = Linkedin;

Linkedin.default = Linkedin;
